<div class="loader-while" *ngIf="!detailsParsed">
    <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
  </div>
<div class="asset-details-section" *ngIf="detailsParsed">
  <div class="asset-details-card-containers-header">
    <div class="asset-details-card-containers">
      <div class="other-card">
        <!--<div class="item-balance">{{pi.balance}}</div>-->
        <div class="other-card-img" [ngClass]="{'full-image':pi.metadata.properties.category=='armor'}">
          <img src="{{pi.metadata.image}}" />
        </div>
        <div class="other-card-content">
          <div class="name-row">
            <span>{{pi.metadata.nameFormatted}}</span>
            <span>Type: {{pi.metadata.typeFormatted}}</span>
            <!--<span>Description: {{pi.metadata.descriptionFormatted}}</span>-->
            <!--<span *ngIf="pi.data.order" class="price-span">${{pi.data.order.priceUSD.toLocaleString()}}</span>-->
          </div>
          <div class="nft-crafting-progress" *ngIf="pi.craftingPercentage">
            <div class="nft-crafting-level-icon" *ngFor="let cr of craftingLevels">
              <img src="./assets/img/nftItems/tiers/level-{{cr.level}}.png" [ngClass]="{'unselected': cr.level!=pi.craftingStage}" />
            </div>
            <!--<span>[{{pi.craftingStage}}/{{pi.craftingMax}}]</span>
          <div class="progress-bar">
                <span class="progress-bar-fill" style="width: {{pi.craftingPercentage}}%;"></span>
              </div>-->
          </div>
          <div class="nft-icon" *ngIf="pi.kind=='nft'">
            <img src="./assets/img/Icon/nft-icon.svg" *ngIf='!pi.metadata.properties.bound' />
            <img src="./assets/img/Icon/nft-bound.png" *ngIf='pi.metadata.properties.bound' />
          </div>
        </div>
      </div>
    </div>
    <div class="asset-details-infos-containers">
      <div class="asset-details-header" *ngIf="pi.kind=='nft'">
        <div class="asset-details-listing-sale">
          <div class="item-block" *ngIf="pi.order">
            <img src="./assets/img/Icon/kmon-logo-micro.png">
            <span>{{pi.order.priceFormatted.toLocaleString()}}</span>
          </div>
        </div>
        <div class="asset-details-buttons">
          <div class="button-outline" *ngIf="pi.craftingStage<4 && pi.craftingStage!==undefined || pi.metadata.properties.bound" (click)="openCraft(pi)">
            Craft
          </div>
          <div class="button-gradient" *ngIf="!pi.metadata.properties.bound && !pi.order &&  !isLoading && !isSuccess" (click)="showSaleModal=true">
            Sell
          </div>
          <div class="button-gradient" *ngIf="!pi.metadata.properties.bound && pi.order && !isLoading && !isSuccess" (click)="cancelListing()">
            Remove from sale
          </div>
          <div class="button-gradient" *ngIf="!isLoading && isSuccess">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
          </div>
          <div class="button-gradient" *ngIf="isLoading && !isSuccess">
            <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
          </div>
          <div class="button-grey" *ngIf="!pi.metadata.properties.bound" (click)="showTransferModal=true">
            Transfer
          </div>
        </div>
      </div>
      <div class="asset-details-details">
        <h1>{{pi.metadata.nameFormatted}}</h1>
        <p>{{pi.metadata.descriptionFormatted}}</p>
      </div>
      <div class="asset-details-inside-content">
      </div>
    </div>
  </div>
  <div class="asset-details-other-items" *ngIf="pi.kind=='nft'">
    <h3>Your other items</h3>
    <div class="asset-details-other-items-container">
      <div class="other-card" *ngFor="let ot of otherItems | itemsFilterType: filterItemCategory">
        <div class="other-card-img" [ngClass]="{'full-image':ot.metadata.properties.category=='armor'}">
          <img src="{{ot.metadata.image}}">
          <div class="cr cr-top cr-right cr-purple" *ngIf="ot.order">On sale</div>
        </div>
        <div class="other-card-content">
          <div class="name-row">
            <span>{{ot.metadata.nameFormatted}}</span>
            <span>Type: {{ot.metadata.typeFormatted}}</span>
          </div>
          <div class="button-outline button-outline-xs" (click)="openDetails(ot)">
            Details
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="asset-details-other-items">
    <h3>From Primus Bazar</h3>
    <div class="asset-details-other-items-container">
      <div class="other-card" *ngFor="let ot of ingameItems">
        <div class="other-card-img">
          <img src="{{ot.img}}">
        </div>
        <div class="other-card-content">
          <div class="name-row">
            <span>{{ot.titleFormatted}}</span>
            <span>Type: {{ot.typeFormatted}}</span>
          </div>
          <div class="button-outline button-outline-xs" (click)="openPrimusBazar(ot)">
            Buy
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="asset-details-other-items">
  	<div class="title-filter">
    <h3>From the Auction House</h3>
    <div class="right-actions">
      <div class="action-life" (click)="filterAuction=''">
        <!--<fa-icon [icon]="['fas', 'times']"></fa-icon>-->
        <span>Show all</span>
      </div>
      <div class="action-life" (click)="filterAuction='hunting boost'">
        <img src="./assets/img/nftItems/Tag-Gold.png" />
        <span>Badges</span>
      </div>
      <div class="action-life" (click)="filterAuction='equipment'">
        <img src="./assets/img/nftItems/Vanquisher-Helmet-Bronze.png" />
        <span>Equipment</span>
      </div>
      <div class="action-life" (click)="filterAuction='caring boost'">
        <img src="./assets/img/nftItems/Training-1.png" />
        <span>Powerups</span>
      </div>
      <!--<div class="action-life" (click)="filterAuction='sold'">
        <img src="./assets/img/Icon/sold-small.png" />
        <span>Sold</span>
      </div>-->
      </div>
    </div>
    <div class="asset-details-other-items-container">
      <div class="other-card" *ngFor="let ot of otherItemsBuy | itemsFilterType: filterAuction">
        <div class="other-card-img" [ngClass]="{'full-image':ot.metadata.properties.category=='armor'}">
          <img src="{{ot.metadata.image}}">
        </div>
        <div class="other-card-content">
          <div class="name-row">
            <span>{{ot.metadata.nameFormatted}}</span>
            <span>Type: {{ot.metadata.typeFormatted}}</span>
          </div>
          <div class="button-outline button-outline-xs" (click)="openAuctionHouse(ot)">
            Buy
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="transfer-modal-overlay" *ngIf="showTransferModal">
    <div class="transfer-modal">
      <div class="transfer-modal-transfer" *ngIf="!isSuccess">
        <div class="transfer-modal-text">
          <h3>Transfer</h3>
          <p class="text-gray">You are about to send this {{pi.metadata.nameFormatted}} to another wallet</p>
          <p class="text-gray">Please enter the receiver address below.</p>
        </div>
        <div class="transfer-modal-input">
          <p>Wallet Address</p>
          <input type="text" placeholder="0x00000..." [(ngModel)]="receiverAddress" (ngModelChange)="isValidAddressKmon()" />
        </div>
        <div class="transfer-modal-buttons">
          <div class="button-outline" (click)="showTransferModal=false" *ngIf="!isLoading">
            Cancel
          </div>
          <div class="button-gradient" *ngIf="validAddress && !isLoading" (click)="checkAllowanceItems()">
            Proceed
          </div>
          <div class="button-gradient disabled" *ngIf="!validAddress">
            Proceed
          </div>
          <div class="button-gradient" *ngIf="isLoading">
            <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
          </div>
        </div>
      </div>
      <div class="transfer-modal-success" *ngIf="isSuccess">
        <div class="transfer-modal-text">
          <h3>Success</h3>
          <p>The Kryptomon {{pi.metadata.nameFormatted}} has been successfully transfered.</p>
        </div>
        <div class="transfer-modal-buttons">
          <div class="button-outline" (click)="closeTransferProcedure()">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sale-modal-overlay" *ngIf="showSaleModal">
    <div class="sale-modal">
      <div class="sale-listing-init" *ngIf="!showConfirmationListing && !isSuccess">
        <div class="other-card">
          <div class="popup-sale-left">
            <div class="popup-card">
              <!--<div class="item-balance">{{pi.balance}}</div>-->
              <div class="other-card-img" [ngClass]="{'full-image':pi.metadata.properties.category=='armor'}">
                <img src="{{pi.metadata.image}}" />
              </div>
              <div class="other-card-content">
                <div class="name-row">
                  <span>{{pi.metadata.nameFormatted}}</span>
                  <span>Type: {{pi.metadata.typeFormatted}}</span>
                  <!--<span>Description: {{pi.metadata.descriptionFormatted}}</span>-->
                  <!--<span *ngIf="pi.data.order" class="price-span">${{pi.data.order.priceUSD.toLocaleString()}}</span>-->
                </div>
                <div class="nft-crafting-progress" *ngIf="pi.craftingPercentage">
                  <div class="nft-crafting-level-icon" *ngFor="let cr of craftingLevels">
                    <img src="./assets/img/nftItems/tiers/level-{{cr.level}}.png" [ngClass]="{'unselected': cr.level!=pi.craftingStage}" />
                  </div>
                  <!--<span>[{{pi.craftingStage}}/{{pi.craftingMax}}]</span>
              <div class="progress-bar">
                    <span class="progress-bar-fill" style="width: {{pi.craftingPercentage}}%;"></span>
                  </div>-->
              </div>
              <div class="nft-icon" *ngIf="pi.kind=='nft'">
                <img src="./assets/img/Icon/nft-icon.svg" *ngIf='!pi.metadata.properties.bound' />
                <img src="./assets/img/Icon/nft-bound.png" *ngIf='pi.metadata.properties.bound' />
              </div>
            </div>
          </div>
        </div>
        <div class="popup-sale-right">
          <div class="sale-details-input">
          <div class="sale-input-titles">
            <h3>LIST FOR SALE</h3>
            <p class="text-gray">Set price and expiration date for {{pi.metadata.nameFormatted}}</p>
            <div class="prices">
              <span *ngIf="listingPrice>0"><img src="./assets/img/Icon/kmon-logo-micro.png">{{listingPrice.toLocaleString()}}</span>
              <span *ngIf="listingPrice==undefined || listingPrice=='' || listingPrice == 0"><img src="./assets/img/Icon/kmon-logo-micro.png">0</span>
              <span>{{usdPrice.toLocaleString()}}$</span>
            </div>
          </div>
          <div class="sale-input-fields">
            <div class="sale-input-field">
              <p>Price</p>
              <div class="input-price">
                <span><img src="./assets/img/Icon/kmon-logo-micro.png"></span>
                <input type="number" [(ngModel)]="listingPrice" placeholder="2,000" (ngModelChange)="updateKMONPrice()">
              </div>
            </div>
            <div class="sale-input-field">
              <p>Expiration Date</p>
              <input type="date" [ngModel]="expirationDate | date:'dd/mm/yy'" placeholder="dd/mm/yyyy" (ngModelChange)="checkDateValidity($event)">
            </div>
          </div>
          <div class="sale-modal-buttons">
            <div class="button-outline" (click)="showSaleModal=false" *ngIf="!isLoading">
              Cancel
            </div>
            <div class="button-gradient" (click)="showConfirmationListing=true" *ngIf="listingPrice>0 && expirationDateUnix>0">
              List for sale
            </div>
            <div class="button-gradient disabled" *ngIf="listingPrice==undefined || listingPrice=='' || expirationDateUnix==0 || listingPrice<=0">
              List for sale
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
      <div class="sale-listing-confirm" *ngIf="showConfirmationListing && !isSuccess">
        <div class="sale-modal-text">
          <h3>Please confirm</h3>
          <p>You are about to list {{pi.metadata.nameFormatted}} on sale for {{listingPrice.toLocaleString()}}KMON</p>
          <p>Please re-enter the price to confirm.</p>
        </div>
        <div class="sale-modal-input">
          <p>Price</p>
          <div class="input-price">
            <img src="./assets/img/Icon/kmon-logo-micro.png">
            <input type="number" [(ngModel)]="confirmPrice" placeholder="2,000" min="0">
          </div>
        </div>
        <div class="sale-modal-buttons">
          <div class="button-outline" (click)="showConfirmationListing=false" *ngIf="!isLoading">
            Cancel
          </div>
          <div class="button-gradient" *ngIf="(confirmPrice==listingPrice) && !isLoading" (click)="initiateSaleListing()">
            Proceed
          </div>
          <div class="button-gradient disabled" *ngIf="confirmPrice!==listingPrice">
            Proceed
          </div>
          <div class="button-gradient" *ngIf="isLoading">
            <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
          </div>
        </div>
      </div>
      <div class="sale-listing-success" *ngIf="isSuccess">
        <img src="{{pi.metadata.image}}" />
        <h3>Your {{pi.metadata.nameFormatted}} has been listed for sale</h3>
        <div class="sale-modal-buttons">
          <div class="button-outline" (click)="closeListingProcedure()">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
